import Vue from 'vue';
import App from './App.js';
import store from 'store/store.js';
import Vuex from 'vuex';
import Router from 'vue-router';
import {routes} from './router.js';
import axios from 'axios';
import {prefix_m} from './constant.js';
import Service from 'src/service.js';

Vue.use(Router);
Vue.use(Vuex);


const router = new Router({
 mode: 'hash',
	routes
});


router.beforeEach((to, from, next) => {
	var path_routes = [];

	routes.slice(0,routes.length-2).forEach((el) => {
		path_routes.push( el.path)
	})

	path_routes.push("/");
	path_routes.push("");

	if (path_routes.indexOf(to.path)!=-1) {

		axios.get( prefix_m + '/status')
		.then( response => {
			if (response.data.status && Service.getCookie('fullname')) {
				if (to.path == "/view_emp") {
					next( "/view_emp");
				}
				else {
					next( "/report");
				}
			}
			else {
				next( "/auth");
			}
		})
		.catch(function (error) {
			console.log(error);
		});
	}
	else if (to.path == "/logout") {
		axios.get( prefix_m + '/logout')
		.then(response =>{
			Service.deleteCookie('fullname');
		})
		.catch(function (error) {
			console.log(error);
		});

		axios.get(prefix_m + '/status')
			.then(response => {
				if (response.data.status && Service.getCookie('fullname')) {
					next("/report");
				}
				else {
					next("/auth");
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	}
	next();
});

new Vue({
	el: '#app',
	render: h => h(App),
	store: store,
	router: router
});



// WEBPACK FOOTER //
// ./src/main.js